import { Box } from "@chakra-ui/react";
import { Outlet } from "react-router";

export const HelpWrapper = () => (
  <Box h="100%" pb="60px">
    <Outlet />
  </Box>
);
